/**
 * class for WorldMap tile scroller
 */
export class WorldMapBackgroundTiles extends G.PoolGroup {
  /**
   * @params {WorldMap} map
   */
  constructor(map) {
    // eslint-disable-next-line no-use-before-define
    super(WorldMapBackgroundTile);

    this.position = map.position;
    this._sprites = this._getTileSprites();
    this._mapTilesHeight = this._sprites.map((sprite) => game.cache.getFrame(sprite).height);
    this._totalMapHeight = this._mapTilesHeight.reduce((acc, curr) => acc + curr, 0);
    this._threshold = 100;
    map.signals.onMapScrolled.add(G.Helpers.callOnThreshold(this._threshold, this._checkInstancesPlacements, this));
    G.sb('onScreenResize').add(this._checkInstancesPlacements.bind(this));
  }

  /**
   * @returns {Array.<string>}
   */
  _getTileSprites() {
    let sprites;
    // get tiles from OMTSettings if defind
    if (G.OMTsettings.elements.worldMap && G.OMTsettings.elements.worldMap.tiles) {
      sprites = G.OMTsettings.elements.worldMap.tiles;
    } else { // old format always 4 tiles
      sprites = [
        'Map_background_tileable_0',
        'Map_background_tileable_1',
        'Map_background_tileable_2',
        'Map_background_tileable_3',
      ];
    }
    return sprites;
  }

  /**
   * setup required sprites for tiles
   * @param {number} stepMin
   * @param {number} stepMax
   */
  _setupSprites(stepMin, stepMax) {
    const alreadyExisting = [];
    let childIndex = this.children.length;
    let child;
    while (childIndex--) {
      child = this.children[childIndex];
      if (child.step < stepMin || child.step > stepMax) {
        child.kill();
      } else {
        alreadyExisting.push(child.step);
      }
    }
    for (let step = stepMin; step <= stepMax; step++) {
      if (alreadyExisting.indexOf(step) === -1) {
        this.getFreeElement().init(
          step,
          -this._stepToPx(step),
          this._getSpriteForStep(step),
        );
      }
    }
  }

  /**
   * get sprite for this step segment
   * @param {number} step
   * @returns {string}
   */
  _getSpriteForStep(step) {
    return this._sprites[step % this._mapTilesHeight.length];
  }

  /**
   * get step segments from the specified position
   * @param {number} px
   * @returns {number}
   */
  _getStepFromPxPosition(px) {
    let result = Math.floor(px / this._totalMapHeight) * this._sprites.length;
    for (let i = 0; i < this._mapTilesHeight.length; i++) {
      if (this._stepToPx(result + 1) < px) {
        result++;
      } else {
        return result;
      }
    }
    return null;
  }

  /**
   * get step # to a specified position
   * @param {*} stepNr
   * @returns {number}
   */
  _stepToPx(stepNr) {
    let result = Math.floor(stepNr / this._sprites.length) * this._totalMapHeight;
    for (let lastSteps = 0; lastSteps < stepNr % this._mapTilesHeight.length; lastSteps++) {
      result += this._mapTilesHeight[lastSteps];
    }
    return result;
  }

  /**
   * check / update tile instance posititons
   */
  _checkInstancesPlacements() {
    const startStep = Math.max(0, this._getStepFromPxPosition(this.y - game.height - this._threshold * 1.1));
    const endStep = this._getStepFromPxPosition(this.y + this._threshold * 1.1);
    // remove unnecessary children
    this._setupSprites(startStep, endStep);
  }

  getTotalMapHeight() {
    return this._totalMapHeight || 1311; // 1311 is FISH's totalMapHeight
  }
}

/**
 * class for WorldMap tile instance
 */
class WorldMapBackgroundTile extends G.Image {
  /**
   * cosntructor
   */
  constructor() {
    super(0, 0, null, [0.5, 1]);
  }

  /**
   * init / re-init tile
   * @param {number} step
   * @param {number} y
   * @param {string} sprite
   */
  init(step, y, sprite) {
    this.y = y;
    this.step = step;
    this.changeTexture(sprite);
    this.revive();
  }
}
